import { Role, role } from "./role";
import { UserAccount, userAccount } from "./userAccount";
import { Identifiable } from "./identifiable";
import { ProjectRole } from "./projectRole";
import { id } from "./id";

type TeamMember = {
  projectRole: Identifiable<Role>;
  userAccount: Identifiable<UserAccount>;
  isAdministrator: boolean;
  isMember: boolean;
  isPendingMember: boolean;
  isProjectManager: boolean;
  isCollaborator: boolean;
  isVisitor: boolean;
};

const teamMember: TeamMember = {
  projectRole: { uuid: ProjectRole.PROJECT_MANAGER, ...role },
  userAccount: { ...userAccount, uuid: id },
  isAdministrator: false,
  isMember: false,
  isPendingMember: false,
  isProjectManager: false,
  isCollaborator: false,
  isVisitor: false,
};

export type { TeamMember };

export { teamMember };
